export const urlParse = ( url ) => {
	let parts = url.toString().match( /^\s*("?)\s*(?:([a-z]{3,}):\/\/)?(?:([^\/:]+)(?::(\d+))?)?(?:(\/[^?#]*?)([?#].*?)?)?\s*\1\s*$/i );
	if ( !parts ) return null;
	
	parts = {
		proto:				parts[2] || "", //http, https, ...
		host:				parts[3] || "", //abc.com
		port:				parts[4] ? parseInt( parts[4], 10 ) : "", //8080, ...
		path:				parts[5] ? parts[5] : "", // /, /a/b/c, ...
		query:				parts[6] ? parts[6] : "", //?a=5&b=c#123
		protoWhostWport:	null
	};
	
	if ( parts.proto && parts.host ) {
		parts.protoWhostWport = parts.proto + "://" + parts.host;
		if ( parts.port ) parts.protoWhostWport += ":" + parts.port;
	}
	
	parts.make = ( path, query ) => {
		let ret = "";
		
		if ( parts.protoWhostWport ) ret += parts.protoWhostWport;
		if ( parts.path ) ret += parts.path;
		if ( path ) ret = ret.replace( /\/+$/, "" ) + "/" + path.replace( /^\/+/, "" );
		if ( query ) {
			const fc = query.charAt[0];
			if ( fc != "?" && fc != "#" ) ret += "?";
			ret += query;
		}
		else if ( parts.query ) ret += parts.query;
		
		return ret;
	};
	
	return parts;
};

const objIs = o => typeof( o ) === "object" &&  !Array.isArray( o ) && o !== null;

const objectsArraySort = ( a, prop, desc ) => {
	const r = desc ? -1 : 1;
	a.sort(
		( a, b ) => {
			if ( a[ prop ] < b[ prop ] ) return -r;
			if ( a[ prop ] > b[ prop ] ) return r;
			
			return 0;
		}
	);
	
	return a;
};

const objectSortFilter = ( o, propSort, sortIsAsc, propFilter, propFilterVal ) => {
	if ( !propSort && !propFilter ) return o;
	
	let t = Object.entries( o );
	
	if ( propFilter ) t = t.filter( i => i[1][ propFilter ] === propFilterVal );
	
	if ( propSort ) {
		const r = !!sortIsAsc || sortIsAsc === undefined ? 1 : -1;
		
		t.sort(
			( [ , a ], [ , b ] ) => {
				if ( a[ propSort ] < b[ propSort ] ) return -r;
				if ( a[ propSort ] > b[ propSort ] ) return r;
				
				return 0;
			}
		);
	}
	
	return Object.fromEntries( t );
};

const objectsArraySortFilter = ( a, propSort, sortIsAsc, propFilter, propFilterVal ) => {
	if ( !propSort && !propFilter ) return a;
	
	if ( propFilter ) a = a.filter( i => i[ propFilter ] === propFilterVal );
	
	if ( propSort ) {
		const r = !!sortIsAsc || sortIsAsc === undefined ? 1 : -1;
		
		a.sort(
			( a, b ) => {
				if ( a[ propSort ] < b[ propSort ] ) return -r;
				if ( a[ propSort ] > b[ propSort ] ) return r;
				
				return 0;
			}
		);
	}

	return a;
};

const cyrb53 = ( str, seed = 0 ) => {
	let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
	for ( let i = 0, ch; i < str.length; i++ ) {
		ch = str.charCodeAt( i );
		h1 = Math.imul( h1 ^ ch, 2654435761 );
		h2 = Math.imul( h2 ^ ch, 1597334677 );
	}
	h1 = Math.imul( h1 ^ ( h1 >>> 16 ), 2246822507 ) ^ Math.imul( h2 ^ ( h2 >>> 13 ), 3266489909 );
	h2 = Math.imul( h2 ^ ( h2 >>> 16 ), 2246822507 ) ^ Math.imul( h1 ^ ( h1 >>> 13 ), 3266489909 );
	return 4294967296 * ( 2097151 & h2 ) + ( h1 >>> 0 );
};

const diffDeep = ( () => {
	return {
		VALUE_CREATED:   "created",
		VALUE_UPDATED:   "updated",
		VALUE_DELETED:   "deleted",
		VALUE_UNCHANGED: "unchanged",
		
		map: function ( obj1, obj2 ) {
			if ( this.isFunction( obj1 ) || this.isFunction( obj2 ) ) {
				throw "Invalid argument. Function given, object expected.";
			}
			if ( this.isValue( obj1 ) || this.isValue( obj2 ) ) {
				return {
					type: this.compareValues( obj1, obj2 ),
					data: obj1 === undefined ? obj2 : obj1
				};
			}
			
			let diff = {};
			
			for ( let key in obj1 ) {
				if ( obj1.hasOwnProperty( key ) ) {
					if ( this.isFunction( obj1[ key ] ) ) continue;
					
					var value2 = undefined;
					if ( obj2[ key ] !== undefined ) value2 = obj2[ key ];
					
					diff[ key ] = this.map( obj1[ key ], value2 );
				}
			}
			
			for ( let key in obj2 ) {
				if ( obj2.hasOwnProperty( key ) ) {
					if ( this.isFunction( obj2[ key ] ) || diff[ key ] !== undefined ) continue;
					
					diff[ key ] = this.map( undefined, obj2[ key ] );
				}
			}
			
			return diff;
		},
		compareValues: function ( value1, value2 ) {
			if ( value1 === value2 ) return this.VALUE_UNCHANGED;
			
			if ( this.isDate( value1 ) && this.isDate( value2 ) && value1.getTime() === value2.getTime() ) return this.VALUE_UNCHANGED;
			
			if ( value1 === undefined ) return this.VALUE_CREATED;
			
			if ( value2 === undefined ) return this.VALUE_DELETED;
			
			return this.VALUE_UPDATED;
		},
		isFunction: function ( x ) {
			return Object.prototype.toString.call( x ) === "[object Function]";
		},
		isArray: function ( x ) {
			return Object.prototype.toString.call( x ) === "[object Array]";
		},
		isDate: function ( x ) {
			return Object.prototype.toString.call( x ) === "[object Date]";
		},
		isObject: function ( x ) {
			return Object.prototype.toString.call( x ) === "[object Object]";
		},
		isValue: function ( x ) {
			return !this.isObject( x ) && !this.isArray( x );
		}
	};
} )();

const cloneDeep = o => {
	return JSON.parse( JSON.stringify( o ) );
};

const hash = o => JSON.stringify( o );

const rusDeclOfNum = ( n, titles ) => {
	if ( !titles ) titles = [ "значение", "значения", "значений" ];
	return titles[( n % 10 === 1 && n % 100 !== 11 ) ? 0 : n % 10 >= 2 && n % 10 <= 4 && ( n % 100 < 10 || n % 100 >= 20 ) ? 1 : 2 ]
};

const uniqueHashGen = ( prefix ) => {
	if ( !prefix ) prefix = "";
	
	if ( window && window.crypto && window.crypto.getRandomValues ) return window.crypto.getRandomValues( new Uint8Array( 20 ) ).reduce( ( a, i ) => a += ( i < 16 ? "0" : "" ) + i.toString( 16 ), prefix );
	return prefix + ( Math.floor( (+new Date() * Math.random() + 100 ) ).toString( 16 ) );
};

const objIsEmpty = ( o ) => {
	if ( o ) {
		for ( let i in o ) {
			if ( o.hasOwnProperty( i ) ) return false;
		}
	}
	
	return true;
};

const objEach = ( o, f ) => {
	if ( o && f ) {
		for ( let p in o ) {
			if ( o.hasOwnProperty( p ) ) if ( f( o[ p ], p, o ) === false ) break;
		}
	}
	
	return o;
};

const objReduce = ( o, f, a ) => {
	if ( o && f ) {
		for ( let p in o ) {
			if ( o.hasOwnProperty( p ) ) a = f( a, o[ p ], p, o );
		}
	}
	
	return a;
};

const objGetByIndex = ( o, i ) => {
	if ( o ) {
		for ( let p in o ) {
			if ( o.hasOwnProperty( p ) ) {
				if ( !i ) return o[ p ];
				i--;
			}
		}
	}
	
	return undefined;
};

const objInsertByIndex = ( o, i, id, v ) => {
	const ksvs = Object.entries( o );
	ksvs.splice( i, 0, [ id, v ] );
	return Object.fromEntries( ksvs );
};

const objRemoveByIndex = ( o, i ) => {
	const ksvs = Object.entries( o );
	ksvs.splice( i, 1 );
	return Object.fromEntries( ksvs );
};

const objGetFirstKey = o => {
	if ( o ) {
		for ( const i in o ) {
			if ( o.hasOwnProperty( i ) ) return i;
		}
	}
	
	return undefined;
};

const objGetFirst = o => {
	if ( o ) {
		for ( const i in o ) {
			if ( o.hasOwnProperty( i ) ) return o[ i ];
		}
	}

	return undefined;
};

/*
const fileDownload = ( () => {
	const frId = "_download_links_container_";

	return ( url, name, useLink, load ) => {
		if ( useLink ) {
			let fr = document.getElementById( frId );
			if ( fr ) fr.parentNode.removeChild( fr );

			fr = document.createElement( "iframe" );
			fr.setAttribute( "name", frId );
			fr.setAttribute( "id", frId );
			fr.style.position = "absolute";
			fr.style.width = "1px";
			fr.style.height = "1px";
			fr.style.top = "-10000px";
			fr.style.left = "-10000px";
			document.body.appendChild( fr );
			fr.addEventListener( "load", () => {
				const doc = fr.contentDocument || fr.contentWindow.document;
				const text = doc.innerText;
				if ( load ) load( text ? text : null );
				fr.parentNode.removeChild( fr );
			} );
			const link = document.createElement( "a" );
			link.setAttribute( "target", frId );
			link.setAttribute( "download", name || "" );
			link.href = url;
			document.body.appendChild( link );
			link.click();
			link.remove();
		}
		else window.location = url;

		//	window.open( url, "_blank" );
		/*
      let el = document.getElementById( "iframe_for_download" );
      if ( el ) el.remove();

      el = document.createElement( "iframe" );
      el.style.position = "absolute";
      el.style.width = "1px";
      el.style.height = "1px";
      el.style.top = "-10000px";
      el.style.left = "-10000px";
      document.body.appendChild( el );
      el.src = url;
	}
} )();
*/

const fileDownload = url => {
	window.location = url;
};

const YYYYMMDDtoDDMMYYYY = date => {
	return date.replace( /^\s*(\d{4})\.(\d{1,2})\.(\d{1,2})\s*/, "$3.$2.$1" ); //YYYY-MM-DD => DD.MM.YYYY
};

const DDMMYYYYtoYYYYMMDD = date => {
	return date.replace( /^\s*(\d{1,2})\.(\d{1,2})\.(\d{4})\s*/, "$3-$2-$1" ); //DD.MM.YYYY => YYYY-MM-DD
};

const YYYYMMDDnow = () => {
	return ( new Date() ).toISOString().slice( 0,10 );
}

const YYYYMMDDTHHMMSStoDDMMYYYY_HHMMSS = date => {
	return date.replace( /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:\s*T\s*(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?\s*$/i, "$3.$2.$1 $4:$5:$6" ).replace( /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0:]+$/g, "" ); //YYYY-MM-DD(THH:MM(:SS)?)? => DD.MM.YYYY( HH:MM(:SS)?)?
}

const DDMMYYYY_HHMMSStoYYYYMMDDTHHMMSS = date => {
	return date.replace( /^\s*(\d{1,2}).(\d{1,2}).(\d{4})(?:\s*T\s*(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?\s*$/i, "$3-$2-$1T$4:$5:$6" ).replace( /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0:]+$/g, "" ); //YYYY-MM-DD(THH:MM(:SS)?)? => DD.MM.YYYY( HH:MM(:SS)?)?
}

const YYYYMMDDTHHMMSStoDDMMYYYY_HHMMSS_LOCAL = date => {
	const d = new Date( date + ".000Z" );
	if ( !isNaN( d ) ) {
		const pad = n => n < 10 ? "0" + n : n;

		return pad( d.getDate() ) + "." + pad( d.getMonth() + 1 ) + "." + d.getFullYear() + " " + pad( d.getHours() ) + ":" + pad( d.getMinutes() ) + ":" + pad( d.getSeconds() );
	}

	return date;
}

async function downloadPost( url, data ) {
	/*
	  if CORS conflicts, backend must include something alike following headers:
	  "Access-Control-Allow-Origin":      client host and port (what in address bar in browser like "https://127.0.0.1:8080" )
		"Access-Control-Allow-Methods":     "GET, POST, PUT, DELETE, OPTIONS",
		"Access-Control-Allow-Headers":     "X-PINGOTHER, Origin, X-Requested-With, Content-Type, Accept, Authorization, RefreshToken, X-Server-Opts, Accept, Cache-Control, Pragma, Content-Disposition",
		"Access-Control-Expose-Headers":    "X-PINGOTHER, Origin, X-Requested-With, Content-Type, Accept, Authorization, RefreshToken, X-Server-Opts, Accept, Cache-Control, Pragma, Content-Disposition",
		"Access-Control-Allow-Credentials": "true"

		and for correct file handling:
					  "content-type":		"...",
					  "content-length":	"...",
					  "content-disposition": "attachment; filename="filename.ext"
	*/
	const response = await fetch(
		url,
		{
			method: "POST",
			body: JSON.stringify( data ),
			credentials: "include",
			headers: {
				"Content-Type": "application/json; charset=utf-8",
				Pragma: "no-cache",
				"Cache-Control": "no-cache"
			}
		}
	);
	
	if ( response.status === 200 ) {
		let filename = response.headers.get( "content-disposition" );
		if ( filename ) {
			filename = filename.match( /(?<=")(?:\\.|[^"\\])*(?=")/ )[0];
			let data = await response.blob();
			const blob = new Blob( [data], { type: data.type || "application/octet-stream" } );
			if ( typeof( window.navigator.msSaveBlob ) !== "undefined" ) {
				window.navigator.msSaveBlob( blob, filename );
				return;
			}
			const blobURL = window.URL.createObjectURL( blob );
			const tempLink = document.createElement( "a" );
			tempLink.style.display = "none";
			tempLink.href = blobURL;
			tempLink.setAttribute( "download", filename );
			if ( typeof( tempLink.download ) === "undefined") tempLink.setAttribute( "target", "_blank" );
			document.body.appendChild( tempLink );
			tempLink.click();
			document.body.removeChild( tempLink );
			setTimeout( () => { window.URL.revokeObjectURL( blobURL ); }, 100 );
		}
	}
	else {
	  throw new Error( response.statusText ? decodeURI( response.statusText ) : "failed with " + response.status + " code" );
  }
}

let tid = null;
function download( url, handler ) {
	let iframe = document.getElementById( "_iframe_file_download_" );
	if ( iframe ) {
		iframe.onload( null, true );
	}
	else {
		iframe = document.createElement( "iframe" );
		iframe.id = "_iframe_file_download_";
		
		iframe.style.width		= "1px";
		iframe.style.height		= "1px";
		iframe.src						= "about:blank";
		
		iframe.style.display	= "block";
		iframe.style.position	= "absolute";
		iframe.style.left			= "-100000px";
		iframe.style.top			= "-100000px";
		
		iframe = document.body.appendChild( iframe );
	}
	
	function onload( e, fail ) {
		if ( tid ) {
			clearTimeout( tid );
			tid = undefined;
		}
		if ( this.parentNode ) { //if iframe exists
			if ( handler ) {
				let doc;
				try {
					doc = iframe.contentDocument || iframe.contentWindow.document;
				}
				catch ( e ) {}
				handler( fail !== true, iframe, doc, doc ? doc.firstChild.innerHTML : undefined );
				doc = undefined;
			}
			iframe.parentNode.removeChild( iframe );
		}
		iframe = null;
	}

	iframe.onload = onload;
	
	let tid = setTimeout(
		function() {
			onload( null, true );
		},
		5000
	);

	iframe.src = url;
}

const domFindUp = ( el, cn, jumps ) => {
	if ( jumps === undefined ) jumps = 10;

	while ( el ) {
		if ( el.classList.contains( cn ) ) return el;
		
		el = el.parentNode;
		
		if ( jumps ) {
			if ( jumps <= 1 ) break;
			jumps--;
		}
	}
	
	return null;
}

const scrollIntoViewIfNeeded = ( el ) => {
	new IntersectionObserver(
		( entries, observer ) => {
			entries.forEach(
				entry => {
					if ( entry.intersectionRatio < 1 ) {
						el.scrollIntoView(
							{
								block:  "nearest",
								inline: "nearest",
							}
						);
					}
				}
			);
			
			observer.disconnect();
		},
		{
			root: null,
			rootMargin: "-20px"
		}
	).observe( el );
};

const getAbsRect = el => {
	const c = {
		...el.getBoundingClientRect()
	};
	
	const wsx = window.scrollX;
	const wsy = window.scrollY;
	
	c.x += wsx;
	c.left += wsx;
	c.right += wsx;

	c.y += wsy;
	c.top += wsy;
	c.bottom += wsy;
};

const capitalize = str => {
  return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
};

const emptyOrWhitespaced = str => {
  return !str || !str.trim().length;
};

const uriCharsValid = uri => {
  return !/[\u0000-\u0020"<>^`{|}]/.test( uri );
};

const debounce = ( fn, timeout ) => {
  let tid = null;
  
  return function() {
    const args = arguments;
    const that = this;

    if ( tid ) clearTimeout( tid );
    tid = setTimeout(
      () => {
        tid = null;
        fn.apply( that, args )
      },
      timeout || 10
    );
  }
};

const delay = timeout => {
	return new Promise(
		( res, rej ) => {
			setTimeout( () => { res( timeout ); }, timeout );
		}
	);
};

const hexToRGBA = ( hex, opacity ) => {
	const bigint = parseInt( hex.substring( 1 ), 16 );
	const r = ( bigint >> 16 ) & 255;
	const g = ( bigint >> 8 ) & 255;
	const b = bigint & 255;

	return `rgba( ${r}, ${g}, ${b}, ${opacity} )`;
};

export default {
	urlParse,
  uriCharsValid,
	objectsArraySort,
	objectsArraySortFilter,
	objectSortFilter,
	cyrb53,
	diffDeep,
	cloneDeep,
	hash,
	rusDeclOfNum,
	uniqueHashGen,
	objIsEmpty,
	objIs,
	objEach,
	objReduce,
	objGetByIndex,
	objGetFirstKey,
	objGetFirst,
	objInsertByIndex,
	objRemoveByIndex,

	fileDownload,

	YYYYMMDDtoDDMMYYYY,
	YYYYMMDDnow,
	YYYYMMDDTHHMMSStoDDMMYYYY_HHMMSS,
	YYYYMMDDTHHMMSStoDDMMYYYY_HHMMSS_LOCAL,
	DDMMYYYYtoYYYYMMDD,
	DDMMYYYY_HHMMSStoYYYYMMDDTHHMMSS,
	
	download,
	downloadPost,
	
	domFindUp,
	scrollIntoViewIfNeeded,
	getAbsRect,
  
  capitalize,
  emptyOrWhitespaced,
  
  debounce,

	delay,

	hexToRGBA
};
